import React, { useState, useEffect, useRef }  from 'react';
import styles from 'components/show_drawing/redraw_form/_style.module.scss';
import MyEventListener from 'components/common/MyEventListener.jsx'
import Constants from 'components/show_drawing/Constants.jsx';

const MaterialGroupChooser = ({ id, unit, drawing, setId }) => {
  const [value, setValue] = useState(id);
  const labelRef = useRef();

  const emitLabelWidth = () => {
    if (labelRef.current) {
      emitEvent(Constants.drawing_input_label_width, { id: id, name: 'material_group', width: $(labelRef.current).width(), group: 'dropdowns' })
    }
  }

  const adjustLabelWidthMsg = (e) => {
    if (e.detail.id == id && e.detail.name != 'material_group' && e.detail.group == 'dropdowns' && labelRef.current) {
      let myWidth = $(labelRef.current).width();
      let othersWidth = e.detail.width;
      if (othersWidth > myWidth) {
        $(labelRef.current).width(othersWidth);
      }
    }
  }

  const onChange = (e) => {
    e.preventDefault();
    setValue( () => e.target.value )
  }

  // useEffect
  useEffect( () => {
    if(id != value) { setId( () => value ) }
  }, [value])

  useEffect( () => { setValue( () => id) }, [id, unit, drawing] )
  useEffect(emitLabelWidth, [labelRef.current])
  // useEffect

  MyEventListener([
    {
      key: Constants.drawing_input_label_width,
      callback: adjustLabelWidthMsg
    }
  ])

  if(drawing == undefined) { return }
  if(drawing.main_group_chooser.drawing_id_in_cartons == undefined && drawing.main_group_chooser.drawing_id_in_corrugated == undefined) { return }

  return (
    <div className={styles.row}>
      <div className="input-group" style={{ width: '100%' }}>
        <span className={`d_input_add_on input-group-addon input-group-addon-${window.locale} ${styles.input_add_on}`} ref={labelRef}>
          { t('drawing.choose_main_group') }
        </span>
        <select value={value} onChange={onChange} className="form-control">
          <option value={drawing.main_group_chooser.drawing_id_in_cartons != undefined ? drawing.main_group_chooser.drawing_id_in_cartons : id }> {t('models.material_cartons')} </option>
          <option value={drawing.main_group_chooser.drawing_id_in_corrugated != undefined ? drawing.main_group_chooser.drawing_id_in_corrugated : id}> {t('models.material_corrugated_cardboards')} </option>
        </select>
      </div>
    </div>
  )
}

export default MaterialGroupChooser;
